
















































import { StepConfig } from '@/store/modules/jtms/course/course.types';
import {
  Vue,
  Component,
  Prop,
  Model,
  Emit,
  Watch
} from 'vue-property-decorator';

@Component
export default class CheckoutStepperComponent extends Vue {
  @Prop({ required: true }) readonly validSteps!: StepConfig[];
  @Prop({ default: false }) readonly showBackButton!: boolean;
  @Prop({ default: false }) readonly shouldDisableStepperComponent!: boolean;
  @Model('change', { type: Number, default: 0 }) readonly value!: number;

  // Internal state to track animation direction
  transitionName: string = 'slide-next';

  get activeStepIndex(): number {
    return this.value;
  }

  set activeStepIndex(val: number) {
    this.updateActiveStep(val);
  }

  /**
   * Helper to get the ID of the current step (e.g., 'participants')
   * Used to render the correct slot.
   */
  get activeStepId(): string | number {
    if (this.validSteps && this.validSteps[this.activeStepIndex]) {
      return this.validSteps[this.activeStepIndex].id;
    }
    return '';
  }

  /**
   * Watcher to determine navigation direction.
   * If new index > old index, we are going NEXT (Slide Left).
   * If new index < old index, we are going PREV (Slide Right).
   */
  @Watch('value')
  onStepChange(newVal: number, oldVal: number) {
    if (newVal > oldVal) {
      this.transitionName = 'slide-next';
    } else {
      this.transitionName = 'slide-prev';
    }
  }

  @Emit('change')
  updateActiveStep(val: number) {
    return val;
  }

  @Emit('back')
  handleBackClick() {
    return;
  }

  isStepClickable(step: StepConfig, index: number): boolean {
    if (step.disabled) {
      return false;
    }
    if (step.clickable !== undefined) {
      return step.clickable;
    }
    return index <= this.activeStepIndex;
  }

  /**
   * Only return an icon for completed steps.
   * Active and Future steps will default to showing their Index Number.
   */
  getStepIcon(index: number): string | null {
    if (index < this.activeStepIndex) {
      return 'check';
    }
    return null;
  }
}
